import { createTheme } from '@mui/material/styles';
import { filledInputClasses } from '@mui/material';

const primary = '#675e5c';
const primaryLight = '#efe8e4';
const primaryDark = '#675e5c';

const secondary = '#d80000';
const secondaryLight = '#ff4d4d';
const secondaryDark = '#a60000';

// #D32F2F
const error = '#D32F2F';
const errorLight = '#EF5350';
const errorDark = '#C62828';

// #18B62C
const success = '#18B62C';
const successLight = '#45E659';
const successDark = '#139324';

const disabled = '#9F9F9F';

export const ThemeArtele = createTheme({
  typography: {
    fontFamily: `Montserrat, Sans-Serif`,
    fontSize: 16,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
          backgroundColor: secondary,
          width: 'auto',
          boxShadow: '1px 1px 5px grey',
          paddingLeft: '25px',
          paddingRight: '25px',
          borderRadius: '15px',
          '&:disabled': {
            color: '#ffffff',
            backgroundColor: disabled,
            boxShadow: '1px 1px 5px grey',
          },
          ':hover': {
            backgroundColor: secondaryDark,
            boxShadow: '1px 1px 5px grey',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: '12px',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
          ':hover': {
            backgroundColor: 'white',
          },
          [`&.${filledInputClasses.focused}`]: {
            backgroundColor: 'white',
          },
        },
        input: {
          ':autofill': {
            borderRadius: 'inherit',
          },
        },
      },
    },
  },
  palette: {
    background: {
      default: primary,
    },
    primary: {
      light: primary,
      main: primary,
      dark: primaryDark,
      contrastText: '#ffffff',
    },
    secondary: {
      light: secondaryLight,
      main: secondary,
      dark: secondaryDark,
      contrastText: '#ffffff',
    },
    success: {
      light: successLight,
      main: success,
      dark: successDark,
      contrastText: '#000000',
    },
    error: {
      light: errorLight,
      main: error,
      dark: errorDark,
      contrastText: '#ffffff',
    },
    rootContainer: {
      color: '#675e5c',
      background: primaryLight,
    },
    button: {
      primary: {
        color: '#ffffff',
        background: '#d80000',
        backgroundHover: secondaryDark,
      },
      apple: {
        color: '#000000',
        background: '#ffffff',
        backgroundHover: '#eeeeee',
      },
      confirm: {
        color: '#ffffff',
        background: success,
        backgroundHover: successDark,
      },
      cancel: {
        color: '#ffffff',
        background: error,
        backgroundHover: errorDark,
      },
    },
    menu: {
      color: '#675e5c',
      background: primaryLight,
    },
    progress: {
      circular: {
        primary: primary,
        secondary: secondary,
      },
      linear: {
        primary: secondary,
        secondary: secondaryLight,
      },
    },
    infoIcon: primary,
    dialog: {
      title: {
        color: '#ffffff',
        background: primary,
      },
      primaryButton: {
        color: '#ffffff',
        background: secondary,
        backgroundHover: secondaryDark,
        backgroundDisabled: disabled,
      },
    },
    appBar: {
      top: {
        color: '#ffffff',
        background: primary,
      },
      bottom: {
        color: '#675e5c',
        background: primaryLight,
      },
    },
    textLink: primary,
    card: {
      primary: {
        color: '#ffffff',
        background: primary,
      },
      secondary: {
        color: '#000000',
        background: secondary,
      },
    },
    breadcrumbs: {
      color: '#675e5c',
    },
  },
});
